<div class="summary-section">
  <strong>{{ name }}:</strong>
  <span *ngIf="description">{{ description }}</span>
  <ng-content></ng-content>
</div>
